<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-custom">{{ title }}</div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
// import Config from '../../../config/index'
import formEdit from './add'
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Thêm mới công ty",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
    }
  },
  async mounted () {
    // console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'editCompany' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Chỉnh sửa công ty' : this.title;
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    //check quyền
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (this.mode == 'edit'){
    //   if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
    //     this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    //   }
    // }else {
    //   if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
    //     this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    //   }
    // }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-company' });
    },
    async saveData(params) {
      console.log("params",params)
      var that = this;
      let objects = {
        name: params.name,
        address: params.address,
        website: params.website,
        company_group_id: params.company_group?.id ?? null,
        company_type: params.company_type?.value ?? 'normal',
      }
      var user = {
          username: params.username,
          fullname: params.fullname,
          phone: params.phone,
          email: params.email,
      }
      if (params.password) {
        user.password = params.password;
      }
      objects.user = user;
      objects.modules = params.modules ?? [];
      var images = params.images;
      var token = that.$store.getters.token ? that.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        if (this.mode == 'add') {
          await ApiRepository.post("/_api/company/add", objects, {headers}).then(async function (response) {
            if (response.status === 200) {
              if (images && images.length > 0){
                var type_image = images[0].type;
                if (type_image != 'old_edit') {
                  var object_delete = {type: that.$constants.TYPE_IMAGE.LOGO_COMPANY, object_id: response.data.data.id}
                  console.log("object_deleteobject_deleteobject_delete", object_delete)
                  await ApiRepository.post("/_api/common/delete-s3", object_delete, {headers}).then(async function () {
                    await that.$CoreService.uploadImages(that.$constants.FOLDER_S3.COMPANY, images).then((resImage) => {
                      if (resImage) {
                        var objectImage = resImage[0];//lấy 1 tấm hình
                        that.$CoreService.updateDataImage(that.$constants.TYPE_IMAGE.LOGO_COMPANY, response.data.data.id, objectImage).then(() => {
                            that.redirectEdit();
                        }).catch(async error => {
                            console.log('error', error);
                            that.$toast.add({
                                severity: 'error',
                                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                                detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                                life: 3000
                            });
                            that.$commonFuction.is_loading(false);
                        });
                      } else {
                        that.redirectEdit();
                      }
                    });
                  });
                } else {
                  that.redirectEdit();
                }
              } else {
                that.redirectEdit();
              }
            } else {
              that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: response.data.message,
                  life: 3000
              });
              that.$commonFuction.is_loading(false);
            }
          }).catch((err) => {
            console.log('errorerrorerrorerror', err);
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          })
        } else {
          objects.id = this.$route.params.id;
          await ApiRepository.post("/_api/company/edit", objects, {headers}).then(async function (response) {
            if (response.status === 200) {
              if (images && images.length > 0){
                var type_image = images[0].type;
                if (type_image != 'old_edit') {
                  var object_delete = {type: that.$constants.TYPE_IMAGE.LOGO_COMPANY, object_id: response.data.data.id}
                  console.log("object_deleteobject_deleteobject_delete", object_delete)
                  await ApiRepository.post("/_api/common/delete-s3", object_delete, {headers}).then(async function () {
                    await that.$CoreService.uploadImages(that.$constants.FOLDER_S3.COMPANY, images).then((resImage) => {
                      if (resImage) {
                        var objectImage = resImage[0];//lấy 1 tấm hình
                        that.$CoreService.updateDataImage(that.$constants.TYPE_IMAGE.LOGO_COMPANY, response.data.data.id, objectImage).then(() => {
                            that.redirectEdit();
                        }).catch(async error => {
                            console.log('error', error);
                            that.$toast.add({
                                severity: 'error',
                                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                                detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                                life: 3000
                            });
                            that.$commonFuction.is_loading(false);
                        });
                      } else {
                        that.redirectEdit();
                      }
                    });
                  });
                } else {
                  that.redirectEdit();
                }
              } else {
                that.redirectEdit();
              }
            } else {
              that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: response.data.message,
                  life: 3000
              });
              that.$commonFuction.is_loading(false);
            }
          }).catch((err) => {
            console.log('errorerrorerrorerror', err);
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          })
        }
      }
    },
    async redirectEdit() {
      // console.log("redirectEdit");
      // this.$commonFuction.is_loading(false);
      var that = this;
      var router_back = {path: '/admin/list-company'};
      that.$commonFuction.is_loading(false);
      if(that.mode == 'add'){
        that.$router.push(router_back);
      }else{
        if (!that.$commonFuction.isEmpty(router_back)){
          // that.page_transaction = ""+that.page_transaction
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Lưu dữ liệu thành công', life: 3000 })
    },
    async getData(id) {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/company/detail", {company_id: id}, {headers});
        var value = data.data;
        this.models = value;
        this.componentKey++;
      }
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>